import React from 'react';
import { Card, Input, Grid } from 'semantic-ui-react';
import { CardBody, Col, Label, Row } from 'reactstrap';
import 'react-select/dist/react-select.css'
import 'react-virtualized-select/styles.css'
import Select from 'react-virtualized-select';
import { getValuesOp } from './operaciones';
import { withNamespaces } from 'react-i18next';
import Loader from '../../../../Global/Loader';
import { set } from 'lodash';

function ConvertidorMedidas(props) {
  let [inputMasa, setInputMasa] = React.useState('');
  let [inputLong, setInputLong] = React.useState('');
  let [inputArea, setInputArea] = React.useState('');
  let [inputVol, setInputVol] = React.useState('');

  let [selectMasa, setSelectMasa] = React.useState('kg');
  let [selectMasaConv, setSelectMasaConv] = React.useState('lb');

  let [selectLong, setSelecLong] = React.useState('m');
  let [selectLongConv, setSelecLongConv] = React.useState('ft');

  let [selectArea, setSelectArea] = React.useState('m2');
  let [selectAreaConv, setSelectAreaConv] = React.useState('ft2');

  let [selectVol, setSelectVol] = React.useState('l');
  let [selectVolConv, setSelectVolConv] = React.useState('T');

  let [resultMasa, setResultMasa] = React.useState('');
  let [resultLongitud, setResultLongitud] = React.useState('');
  let [resultArea, setResultArea] = React.useState('');
  let [resultVol, setResultVol] = React.useState('');
  const UnidadesMetricas = {
    masa: [
      { key: "oz", value: "oz", label: props.t("ounce"), um: props.t("mass") },
      { key: "g", value: "g", label: props.t("gram"), um: props.t("mass") },
      { key: "kg", value: "kg", label: props.t("kilogram"), um: props.t("mass") },
      { key: "lb", value: "lb", label: props.t("pound"), um: props.t("mass") },
      { key: "shortton", value: "short ton", label: props.t("short_ton"), um: props.t("mass") },
      { key: "T", value: "T", label: props.t("metric_ton"), um: props.t("mass") },
    ],
    longitud: [
      { key: "m", value: "m", label: props.t("meter"), um: props.t("length") },
      { key: "mm", value: "mm", label: props.t("milimeter"), um: props.t("length") },
      { key: "km", value: "km", label: props.t("kilometer"), um: props.t("length") },
      { key: "in", value: "in", label: props.t("inch"), um: props.t("length") },
      { key: "ft", value: "ft", label: props.t("feet"), um: props.t("length") },
      { key: "yd", value: "yd", label: props.t("yard"), um: props.t("length") },
      { key: "mi", value: "mi", label: props.t("statute_mile"), um: props.t("length") },
      { key: "min", value: "min", label: props.t("nautical_mile"), um: props.t("length") },
    ],
    area: [
      { key: "km2", value: "km2", label: props.t("square_kilometer"), um: props.t("area") },
      { key: "m2", value: "m2", label: props.t("square_meter"), um: props.t("area") },
      { key: "yd2", value: "yd2", label: props.t("square_yard"), um: props.t("area") },
      { key: "ft2", value: "ft2", label: props.t("square_feet"), um: props.t("area") },
      { key: "in2", value: "in2", label: props.t("square_inch"), um: props.t("area") },
      { key: "ha", value: "ha", label: props.t("hectare"), um: props.t("area") },
      { key: "acre", value: "acre", label: props.t("acre"), um: props.t("area") },
    ],
    volumen: [
      { key: "l", value: "l", label: props.t("liter"), um: props.t("volume") },
      { key: "ml", value: "ml", label: props.t("milliliter"), um: props.t("volume") },
      { key: "m3", value: "m3", label: props.t("cubic_meter"), um: props.t("volume") },
      { key: "in3", value: "in3", label: props.t("cubic_inch"), um: props.t("volume") },
      { key: "ft3", value: "ft3", label: props.t("cubic_feet"), um: props.t("volume") },
      //{ key: "yd3", value: "yd3", label: "Yarda Cubica", um: props.t("volume")  },
      { key: "room", value: "room", label: props.t("quarter_usa"), um: props.t("volume") },
      { key: "TT", value: "TT", label: props.t("gallon_usa"), um: props.t("volume") },
      { key: "T", value: "T", label: props.t("gallon"), um: props.t("volume") },
    ],
  };
  function Validator(params) {
    // return new RegExp(/^\d*\.?\d*$/).test(params)
    // return new RegExp(/^-?(?:0?[1-9]\d*|0)$/).test(params)

    // return new RegExp(/^(?:0?\.?[1-9]\d*|\d?)$/).test(params)

    // return new RegExp(/^(?:(0\.\d*)|(0?[1-9]?)|(0?[1-9]\.\d*)|(0?[1-9]\d*\.\d*))$/).test(params)
    return new RegExp(/^(?:(0\.\d*)|([1-9]\.?\d*)|([1-9]*0*?\.\d*)|(0?\.?))$/).test(params)
  }

  const inputHandler = (tableName) => {
    let rende;
    if (tableName === props.t("mass")) {
      rende = (
        <Input
          fluid
          style={{
            // width: "100%",
            color: "#323C47",
            fontSize: "12px",
          }}
          // type="number"
          placeholder='0'
          value={inputMasa}
          onChange={(e, { value }) => {
            let res = Validator(value)
            console.log("🚀 ~ file: index.js ~ line 59 ~ inputHandler ~ res", res)
            if (res) {
              setInputMasa(value)
              operaciones(tableName, value, selectMasa, selectMasaConv)
            }
          }}
        // onChange={(e, { value }) => (
        //   setInputMasa(value),
        //   operaciones(tableName, value, selectMasa, selectMasaConv)
        // )}
        />
      );
    }

    if (tableName === props.t("length")) {
      rende = (
        <Input
          fluid
          // type="number"
          placeholder='0'
          value={inputLong}
          // onChange={(e, { value }) => (
          //   setInputLong(value),
          //   operaciones(tableName, value, selectLong, selectLongConv)
          // )}
          onChange={(e, { value }) => {
            let res = Validator(value)
            if (res) {
              setInputLong(value)
              operaciones(tableName, value, selectLong, selectLongConv)
            }
          }}
        />
      );
    }

    if (tableName === props.t("area")) {
      rende = (
        <Input
          fluid
          // type="number"
          value={inputArea}
          placeholder='0'
          onChange={(e, { value }) => {
            let res = Validator(value)
            if (res) {
              setInputArea(value)
              operaciones(tableName, value, selectArea, selectAreaConv)
            }
          }}
        // onChange={(e, { value }) => (
        //   setInputArea(value),
        //   operaciones(tableName, value, selectArea, selectAreaConv)
        // )}
        />
      );
    }

    if (tableName === props.t("volume")) {
      rende = (
        <Input
          fluid
          // type="number"
          value={inputVol}
          placeholder='0'
          onChange={(e, { value }) => {
            let res = Validator(value)
            if (res) {
              setInputVol(value)
              operaciones(tableName, value, selectVol, selectVolConv)
            }
          }}
        // onChange={(e, { value }) => (
        //   setInputVol(value),
        //   operaciones(tableName, value, selectVol, selectVolConv)
        // )}
        />
      );
    }

    return rende;
  };

  const resultHandler = (tableName) => {
    let result;
    if (tableName === props.t("mass")) {
      result = resultMasa;
    }

    if (tableName === props.t("length")) {
      result = resultLongitud;
    }

    if (tableName === props.t("area")) {
      result = resultArea;
    }

    if (tableName === props.t("volume")) {
      result = resultVol;
    }

    return result;
  };

  const unidadInicial = (tableName, event) => {
    if (tableName === props.t("mass") && event) {
      setSelectMasa(event.value);
      operaciones(event.um, inputMasa, event.value, selectMasaConv);
    }
    if (tableName === props.t("mass") && !event) {
      setSelectMasa('');
      setResultMasa('');
    }

    if (tableName === props.t("length") && event) {
      setSelecLong(event.value);
      operaciones(event.um, inputLong, event.value, selectLongConv);
    }
    if (tableName === props.t("length") && !event) {
      setSelecLong('');
      setResultLongitud('');
    }

    if (tableName === props.t("area") && event) {
      setSelectArea(event.value);
      operaciones(event.um, inputArea, selectArea, event.value);
    }
    if (tableName === props.t("area") && !event) {
      setSelectArea('');
      setResultArea('');
    }

    if (tableName === props.t("volume") && event) {
      setSelectVol(event.value);
      operaciones(event.um, inputVol, selectVol, event.value);
    }
    if (tableName === props.t("volume") && !event) {
      setSelectVol('');
      setResultVol('');
    }
  };

  const unidadAConvertir = (tableName, event) => {
    if (tableName === props.t("mass") && event) {
      setSelectMasaConv(event.value);
      operaciones(event.um, inputMasa, selectMasa, event.value);
    }
    if (tableName === props.t("mass") && !event) {
      setSelectMasaConv('');
      setResultMasa('');
    }

    if (tableName === props.t("length") && event) {
      setSelecLongConv(event.value);
      operaciones(event.um, inputLong, selectLong, event.value);
    }
    if (tableName === props.t("length") && !event) {
      setSelecLongConv('');
      setResultLongitud('');
    }

    if (tableName === props.t("area") && event) {
      setSelectAreaConv(event.value);
      operaciones(event.um, inputArea, selectArea, event.value);
    }
    if (tableName === props.t("area") && !event) {
      setSelectAreaConv('');
      setResultArea('');
    }

    if (tableName === props.t("volume") && event) {
      setSelectVolConv(event.value);
      operaciones(event.um, inputVol, selectVol, event.value);
    }
    if (tableName === props.t("volume") && !event) {
      setSelectVolConv('');
      setResultVol('');
    }
  };

  const operaciones = (tableName, value, fin, sin) => {
    if (tableName === props.t("mass")) {
      if (value && fin && sin) {
        setResultMasa(getValuesOp.Masa(value, fin, sin));
      } else {
        setResultMasa('');
      }
    }

    if (tableName === props.t("length")) {
      if (value && fin && sin) {
        setResultLongitud(getValuesOp.Longitud(value, fin, sin));
      } else {
        setResultLongitud('');
      }
    }

    if (tableName === props.t("area")) {
      if (value && fin && sin) {
        setResultArea(getValuesOp.Area(value, fin, sin));
      } else {
        setResultArea('');
      }
    }

    if (tableName === props.t("volume")) {
      if (value && fin && sin) {
        setResultVol(getValuesOp.Volumen(value, fin, sin));
      } else {
        setResultVol('');
      }
    }
  };

  const cardContent = (unidades, valDef, valConvert, tableName) => {
    return (
      <>
        <Col xs={12} md={6} lg={6} style={{ marginBottom: '7px' }}>
          <Card fluid style={{ backgroundColor: ' #000a2e' }}>
            <Card.Content>
              <Label style={{ font: 'bold', color: 'white' }}>{tableName === props.t("area") ? props.t("area") : tableName}</Label>
            </Card.Content>
          </Card>
        </Col>
        <Col xs={12} md={12} lg={12}>
          <Card fluid className="CARD UI REACT STRAP BORDER">
            <CardBody>
              <div className='row card-body'>
                <Col
                  xs={12}
                  className={'p-1'}
                >
                  <span>{props.t("convert")}</span>
                </Col>
                <Col xs={3} className={'p-1'}>{inputHandler(tableName)}</Col>
                <Col xs={4} className={'p-1'}>
                  {tableName === props.t("mass") ? (
                    <Select
                      placeholder=""
                      value={selectMasa}
                      onChange={(selectValue) =>
                        unidadInicial(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}
                  {tableName === props.t("length") ? (
                    <Select
                      name={selectLong}
                      placeholder=""
                      value={selectLong}
                      onChange={(selectValue) =>
                        unidadInicial(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}
                  {tableName === props.t("area") ? (
                    <Select
                      placeholder=""
                      value={selectArea}
                      onChange={(selectValue) =>
                        unidadInicial(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}
                  {tableName === props.t("volume") ? (
                    <Select
                      placeholder=""
                      value={selectVol}
                      onChange={(selectValue) =>
                        unidadInicial(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}
                </Col>
                <Col xs={1}
                  style={{ textAlign: 'center', marginTop: '7px' }}
                  className={'p-1'}
                >
                  <center>{props.t("to")}</center>
                </Col>
                <Col xs={4} className={'p-1'}>
                  {tableName === props.t("mass") ? (
                    <Select
                      placeholder=""
                      value={selectMasaConv}
                      onChange={(selectValue) =>
                        unidadAConvertir(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}

                  {tableName === props.t("length") ? (
                    <Select
                      placeholder=""
                      value={selectLongConv}
                      onChange={(selectValue) =>
                        unidadAConvertir(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}

                  {tableName === props.t("area") ? (
                    <Select
                      placeholder=""
                      value={selectAreaConv}
                      onChange={(selectValue) =>
                        unidadAConvertir(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}

                  {tableName === props.t("volume") ? (
                    <Select
                      placeholder=""
                      value={selectVolConv}
                      onChange={(selectValue) =>
                        unidadAConvertir(tableName, selectValue)
                      }
                      options={unidades}
                    />
                  ) : (
                    ''
                  )}
                </Col>
              </div>
              {/* </Row> */}
              {/* </Col> */}
              {/* </Row> */}
              <Row>
                <Col xs={2} md={2} lg={2}>
                  <i
                    class="fas fa-equals"
                    style={{ marginLeft: '15px' }}
                  ></i>
                </Col>
                <Col xs={10} md={10} lg={10}>
                  <Label
                  // style={{ marginBottom: '10px' }}
                  >
                    {resultHandler(tableName)}
                  </Label>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        {/* </Row> */}
        <div className='paddin-footer-5em'></div>

        {/* </div> */}
        {/* </div> */}
      </>
    );
  };

  const init = React.useCallback(async () => {
    setResultMasa(getValuesOp.Masa(0, 'kg', 'lb'));
    setResultLongitud(getValuesOp.Longitud(0, 'm', 'ft'));
    setResultArea(getValuesOp.Area(0, 'm2', 'ft2'));
    setResultVol(getValuesOp.Volumen(0, 'l', 'T'));
  });

  React.useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className='myCard'>
        <CardBody>
          <div className='col-12'>
            <Row>
              <Col xs={12} md={12} lg={6}>
                {/* <div className="col-xs-12 col-md-12 col-lg-6"> */}
                {cardContent(
                  UnidadesMetricas.masa,
                  selectMasa,
                  selectMasaConv,
                  props.t("mass")
                )}
                {/* </div> */}
              </Col>
              <Col xs={12} md={12} lg={6}>
                {/* <div className="col-xs-12 col-md-12 col-lg-6">
            <CardBody> */}
                {cardContent(
                  UnidadesMetricas.longitud,
                  selectLong,
                  selectLongConv,
                  props.t("length")
                )}
                {/* </CardBody>
          </div> */}
              </Col>
              <Col xs={12} md={12} lg={6}>
                {/* <div className="col-xs-12 col-md-12 col-lg-6">
          <CardBody> */}
                {cardContent(
                  UnidadesMetricas.area,
                  selectArea,
                  selectAreaConv,
                  props.t("area")
                )}
                {/* </CardBody>
        </div> */}
              </Col>
              <Col xs={12} md={12} lg={6}>
                {/* <div className="col-xs-12 col-md-12 col-lg-6">
            <CardBody> */}
                {cardContent(
                  UnidadesMetricas.volumen,
                  selectVol,
                  selectVolConv,
                  props.t("volume")
                )}
                {/* </CardBody>
          </div> */}
              </Col>

            </Row>
          </div >

        </CardBody>
      </div >

    </>
  );
}

export default withNamespaces()(ConvertidorMedidas);
